import { Avatar, BadgeNotifications } from '@components/common';
import { ApiHeaderInfoOk } from '@type/v1-api-types';
import { UserCircleIcon } from '@heroicons/react/20/solid';

interface ProfileAvatarProps {
  headerInfo?: ApiHeaderInfoOk,
  className?: string,
}

/**
 * ProfileAvatar Component
 *
 * Displays a user's avatar with an unseen-messages indicator.
 *
 * @example
 * <ProfileAvatar headerInfo={headerData} />
 */
export const ProfileAvatar = (props: ProfileAvatarProps) => {
  // Destructure props
  const { headerInfo, className = '' } = props;

  return (
    <span className={`relative shrink-0 rounded-full ${className}`}>
      <BadgeNotifications count={headerInfo?.nrUnseenMessages || 0} showCount={false} className="absolute -right-1 top-0 -translate-x-1/2" />
      {headerInfo?.profileImg ? (
        <Avatar
          size="xs"
          name={headerInfo?.name}
          imgPath={headerInfo?.profileImg}
          extractImageName
          imgFolder="resume_image"
          aspectRatio="square-uncertain"
          imgPriority
          id={headerInfo?.userId || 1}
          withRing
        />
      )
        : (
          <UserCircleIcon className="size-6 md:size-7" />
        )}
    </span>
  );
};

